import { render, staticRenderFns } from "./DetailsAlerts.vue?vue&type=template&id=72037bb1&"
import script from "./DetailsAlerts.vue?vue&type=script&lang=js&"
export * from "./DetailsAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports